/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react'
import PropTypes from 'prop-types'

import useMedia from '../../helpers/useMedia'
import * as Styled from './ArgosCardPrompt.styles'

const argosCardImage = {
  ALT: 'Fixed credit plans available with Argos Monthly Payment Plan',
  DESKTOP: 'https://media.4rgos.it/i/Argos/argoscard-desktop?w=1140',
  TABLET: 'https://media.4rgos.it/i/Argos/argoscard-tablet?w=768',
  MOBILE: 'https://media.4rgos.it/i/Argos/argoscard-mobile?w=481',
}

const linkUrl = '//www.argos.co.uk/features/argos-monthly-payment-plan?tag=ar:homepage:argosmppbanner'

const ArgosCardPrompt = ({ onCmsClick }) => {
  const argosCardImg = useMedia(
    [argosCardImage.DESKTOP, argosCardImage.TABLET, argosCardImage.TABLET, argosCardImage.MOBILE],
    null,
  )

  if (!argosCardImg) return null
  return (
    <div className='container' data-test='argos-card-prompt'>
      <Styled.ArgosCard
        onClick={(event) => onCmsClick(event, linkUrl)}
        href={linkUrl}
        data-test='argos-card-prompt-link'
        title={argosCardImage.ALT}>
        <Styled.ArgosCardImage src={argosCardImg} data-test='image-argos-card' lazy alt={argosCardImage.ALT} />
      </Styled.ArgosCard>
    </div>
  )
}

ArgosCardPrompt.propTypes = {
  onCmsClick: PropTypes.func.isRequired,
}

export default ArgosCardPrompt
